import React from 'react';
import BaseModalComponent, {
  StyledBaseModal,
  StyledBaseModalContent,
} from './BaseModal.component';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import CardComponent, { StyledCard } from '../Card.component';
import LogoGrayIcon from '../Icons/Logo/LogoGray.icon';
import ComputerHelloIcon from '../Icons/Computer/ComputerHello.icon';

const StyledNoAccessModalBGIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: ${({ theme }) => theme.colors.BG1};
  border-radius: 8px;
`;
const StyledNoAccessModalBody = styled.div`
  & > ${StyledCard} {
    width: 520px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;
    justify-content: center;
  }
`;
const StyledNoAccessModalDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  color: ${({ theme }) => theme.colors.LABEL};
  font-weight: 500;
`;
const StyledNoAccessModalTitle = styled.div`
  color: ${({ theme }) => theme.colors.TITLE};
  font-size: 24px;
  font-weight: 500;
`;
const StyledNoAccessHeaderTitle = styled.div`
  color: ${({ theme }) => theme.colors.TITLE};
  font-size: 24px;
  font-weight: 500;
`;
const StyledNoAccessHeader = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;
const StyledNoAccessModal = styled.div`
  ${StyledBaseModal} > ${StyledCard} {
    background: ${({ theme }) => theme.colors.BG_SPLASH};
  }

  ${StyledBaseModalContent} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 45px;
    width: 100vw;
    height: 100vh;
    max-height: fit-content;
  }
`;

const LOGO_ICON_SIZE = 32;
const NO_ACCESS_ICON_SIZE = 180;

const NoAccessModalComponent = () => {
  const { t } = useTranslation();

  return (
    <StyledNoAccessModal>
      <BaseModalComponent isBlocked={true}>
        <StyledNoAccessHeader>
          <LogoGrayIcon width={LOGO_ICON_SIZE} height={LOGO_ICON_SIZE} />
          <StyledNoAccessHeaderTitle>Hunter</StyledNoAccessHeaderTitle>
        </StyledNoAccessHeader>
        <StyledNoAccessModalBody>
          <CardComponent>
            <StyledNoAccessModalBGIcon>
              <ComputerHelloIcon width={NO_ACCESS_ICON_SIZE} height={NO_ACCESS_ICON_SIZE} />
            </StyledNoAccessModalBGIcon>
            <StyledNoAccessModalTitle>
              {t('Access denied')}
            </StyledNoAccessModalTitle>
            <StyledNoAccessModalDescription>
              <div>{t('You are denied access to this system!')}</div>
            </StyledNoAccessModalDescription>
          </CardComponent>
        </StyledNoAccessModalBody>
      </BaseModalComponent>
    </StyledNoAccessModal>
  );
};

export default NoAccessModalComponent;
